import { defineOverridesPreferences } from '@vben/preferences';

/**
 * @description 项目配置文件
 * 只需要覆盖项目中的一部分配置，不需要的配置不用覆盖，会自动使用默认配置
 * !!! 更改配置后请清空缓存，否则可能不生效
 */
export const overridesPreferences = defineOverridesPreferences({
  // overrides
  app: {
    name: import.meta.env.VITE_APP_TITLE,
    // 默认首页设置为工作台
    // 注意：路径必须与后端菜单配置的path字段一致
    // 后端菜单：path='/workbench', component='/modules/mes/workbench/views/WorkbenchIndex'
    defaultHomePath: '/workbench',
    // 访问权限模式
    // - 'frontend': 前端静态权限模式（权限由前端控制）
    // - 'backend': 后端动态权限模式（权限由后端API返回）
    // 当前使用backend模式，所有菜单和权限由后端API提供
    accessMode: 'backend',
    // 布局模式：侧边栏+顶部混合导航
    layout: 'sidebar-mixed-nav',
    // 启用水印
    watermark: true,
    // 偏好设置按钮：仅开发模式显示
    // - true: 启用设置按钮
    // - false: 禁用设置按钮
    // 使用环境变量判断：开发模式启用，生产模式禁用
    enablePreferences: import.meta.env.DEV,
    // 偏好设置按钮位置
    preferencesButtonPosition: 'header',
    // 登录过期模式
    // - 'modal': 弹窗模式
    // - 'redirect': 重定向模式
    // - 'none': 无模式
    loginExpiredMode: 'modal',
    // 是否启用Token自动刷新
    // - true: 启用，Token过期时自动尝试刷新
    // - false: 禁用，Token过期时直接跳转登录
    enableRefreshToken: true,
    // 动态标题
    // - true: 启用动态标题
    // - false: 禁用动态标题
    dynamicTitle: true,
    // 是否开启检查更新
    enableCheckUpdates: true,
    // 检查更新的时间间隔，单位为分钟
    checkUpdatesInterval: 1,
  },
  // 面包屑配置
  breadcrumb: {
    // 是否显示首页
    showHome: true,
    // 面包屑风格
    styleType: 'background',
  },
  // 版权配置
  copyright: {
    // 公司名称
    companyName: '广西贝叶斯管理咨询有限公司',
    // 公司网站链接
    companySiteLink: 'https://www.bayes.asia',
    // 日期
    date: '2025',
    // 备案链接
    icpLink: 'https://beian.miit.gov.cn/',
  },
  // 底部配置
  footer: {
    // 是否启用
    enable: true,
    // 是否固定
    fixed: true,
  },
  // 侧边栏配置
  sidebar: {
    // 是否折叠
    collapsed: true,
    // 自动激活子菜单
    // 点击一级菜单时，自动激活第一个子菜单或上一次激活的子菜单
    autoActivateChild: true,
    // 折叠按钮
    collapsedButton: false,
    // 固定按钮
    fixedButton: false,
    // 侧边栏宽度
    width: 224,
  },
  // 主题配置
  theme: {
    // 主题模式：auto 跟随系统
    mode: 'auto',
    // 内置主题类型
    builtinType: 'orange',
    // 主色调
    colorPrimary: 'hsl(18 89% 40%)',
    // 圆角，0.5-1之间
    radius: '0.5',
  },
  // Logo 配置
  logo: {
    // 是否启用 logo
    enable: true,
    // 图片适应方式：contain(保持比例) | cover(填充) | fill(拉伸)
    fit: 'contain',
    // Logo 图片路径
    // 本地图片：将 logo 放在 apps/mes/public/ 目录下
    // 例如：apps/mes/public/logo.png
    source: '/logo.png',
    // 或使用在线图片
    // source: 'https://www.bayes.asia/logo.png',
  },
  // 标签页配置
  tabbar: {
    maxCount: 10,
    keepAlive: true,
    middleClickToClose: true,
    styleType: 'card',
  },
  // 页面切换动画配置
  transition: {
    // 是否启用页面切换动画
    enable: false,
  },
  // 右上角工具栏小部件配置
  widget: {
    // 全屏按钮
    fullscreen: true,
    // 全局搜索按钮
    globalSearch: true,
    // 语言切换按钮
    languageToggle: true,
    // 锁屏按钮
    lockScreen: true,
    // 通知按钮（已恢复，使用自定义组件）
    notification: true,
    // 刷新按钮
    refresh: true,
    // 侧边栏折叠按钮
    sidebarToggle: true,
    // 主题切换按钮（亮色/暗色）
    themeToggle: true,
  },
});
